import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

const HeroHealthcare = ({ data }) => {
    if (!data) return null;
    const { title, description, cta, cards, styles } = data;

    return (
        <section
            className="hero-health-care"
            style={{
                background: styles?.background,
                color: styles?.textColor,
                padding: "100px 0"
            }}
        >
            <Container className="hero-container">
                <Row className="align-items-center">

                    {/* LEFT CONTENT */}
                    <Col lg={7} className="hero-col-7">
                        <h1 className="fw-bold display-4">
                            {title.line1} <br />
                            <span style={{ color: styles?.highlightColor }}>
                                {title.highlight}
                            </span>{" "}
                            <br />
                            {title.line2}
                        </h1>

                        <p className="mt-4 fs-5 text-light">
                            {description}
                        </p>

                        <div className="hero-btns mt-4 d-flex flex-wrap gap-3">
                            {cta.map((btn, i) => (
                                <Button
                                    key={i}
                                    tag={Link}
                                    to={btn.link}
                                    className={btn.variant === "primary" ? "btn-grad" : "btn-outline-white"}
                                    outline={btn.variant === "outline"}
                                >
                                    {btn.text}
                                </Button>
                            ))}
                        </div>
                    </Col>

                    {/* RIGHT CARDS */}
                    <Col lg={5} className="hero-stats">
                        <Row className="g-3 mt-4 mt-lg-0">
                            {cards.map((card, i) => (
                                <Col xs={12} md={6} key={i} className="stat-card hi">
                                    <div className="hero-card p-4 h-100">
                                        <div className="stat-ico">{card.icon}</div>
                                        <h4 className="stat-num mt-3 fw-bold text-warning">
                                            {card.title}
                                        </h4>
                                        <p className="stat-lbl mb-0 text-light">
                                            {card.desc}
                                        </p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default HeroHealthcare;